import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { environment } from '../../../environments/environment';
import { SKIP_GLOBAL_LOADER } from '../http/skip-global-loader.token';

function isApiRequest(url: string): boolean {
  const u = url.toLowerCase();
  const api = (environment.apiUrl || '').toLowerCase();
  const security = (environment.securityApiUrl || '').toLowerCase();
  const bot = (environment.botApiUrl || '').toLowerCase();
  return (
    (api.length > 0 && u.startsWith(api)) ||
    (security.length > 0 && u.startsWith(security)) ||
    (bot.length > 0 && u.startsWith(bot))
  );
}

/** Requêtes en arrière-plan (polling, temps réel) : ne pas afficher le loader global. */
function isBackgroundRequest(req: {
  url: string;
  method: string;
  headers: { has: (name: string) => boolean };
  context: { get: (token: typeof SKIP_GLOBAL_LOADER) => boolean };
}): boolean {
  const u = req.url.toLowerCase();
  if (req.context.get(SKIP_GLOBAL_LOADER)) return true;
  if (req.headers.has('X-Skip-Global-Loader')) return true;
  if (req.method !== 'GET' && req.method !== 'HEAD') return false;
  if (u.includes('/me/spotify/now-playing') || u.includes('/spotify/now-playing')) return true;
  if (u.includes('/me/spotify') || u.includes('/me/discord')) return true;
  if (u.includes('/raids/top')) return true;
  return false;
}

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoaderService);
  if (!isApiRequest(req.url) || isBackgroundRequest(req)) {
    return next(req);
  }
  loader.show();
  return next(req).pipe(
    finalize(() => loader.hide())
  );
};

